import { lazy } from 'react'
import { pageUrl } from '../services/pageUrl'

export const risk_routes = [
  // #########################################################################################
  // #############                 RISQUE         ###########################
  // #########################################################################################

  // prévision
  {
    exact: true,
    path: pageUrl.risk.operation_change.liste,
    component: lazy(() =>
      import('../views/menu/risk/operation-changes/liste/table/index')
    ),
  },
  {
    exact: true,
    path: pageUrl.risk.operation_change.fiche,
    component: lazy(() =>
      import('../views/menu/risk/operation-changes/liste/fiche/index')
    ),
  },
  {
    exact: true,
    path: '/foreign_exchange/edit/:id',
    component: lazy(() =>
      import('../views/menu/risk/operation-changes/liste/fiche/index')
    ),
  },
  {
    exact: true,
    path: '/frm_Contrat_change',
    component: lazy(() =>
      import('../views/menu/risk/contrat-change/table/index')
    ),
  },
  {
    exact: true,
    path: '/frm_Contrat_change/new',
    component: lazy(() =>
      import('../views/menu/risk/contrat-change/fiche/index')
    ),
  },
  {
    exact: true,
    path: '/frm_Contrat_change/edit/:id',
    component: lazy(() =>
      import('../views/menu/risk/contrat-change/fiche/index')
    ),
  },
  {
    exact: true,
    path: pageUrl.change_log,
    component: lazy(() => import('../views/menu/help/change-log/index')),
  },
]

